// Values are in seconds
export const APPOINTMENT_TASK_REMINDER_OPTIONS = [
  { label: '15 minutes before', value: 15 * 60 },
  { label: '30 minutes before', value: 30 * 60 },
  { label: '45 minutes before', value: 45 * 60 },
  { label: '1 hour before', value: 60 * 60 },
];
